import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../StyleSheet/MainComponent/UDSEMployee/Udsdashboard.scss";
import Profile from "../../../../Assets/AppComponent/Profile/profile2.png";
import data from "../../../../Json/Language/English";
import hindiDatas from "../../../../Json/Language/Hinid";
import Time from "../../../../Assets/AppComponent/Layer_1 (3).png";
import client from "../../../../Assets/AppComponent/Client.png";
import zone from "../../../../Assets/AppComponent/ZONE.png";
import {
  SetTheShiftDatasActions,
  SetTheAttendanceDatasActions,
  setTheBranchInlatANDLog,
  setTheCheckingIn,
  setTheWhiteCollarState,
  setTheAttendanceId,
} from "../../../../Redux/Slice";
import arrow from "../../../../Assets/AppComponent/Arrow.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
const EmployeeDashboard = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const UserData = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data
  );
  const EnglishData = data;
  const HindiData = hindiDatas;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [EmployeeName, setEmployeeName] = useState();
  const [empRole, setEmpRole] = useState();
  const [EmployeeImage, setImages] = useState();
  const [StartTime, setstartTime] = useState();
  const [endTime, SetEndtime] = useState();
  const [isTimeAfter, setIsTimeAfter] = useState(false);
  ///---let the employee know to punch or pucnh out in based in the ,
  const [CheckIN, setCheckIn] = useState(false);
  const initialState = {
    weekoff: "",
    client_name: "",
    zone_name: "",
  };
  const [Status, setStatus] = useState(initialState);
  const [LeaveState, setLeaveStatus] = useState({
    pending_leave: "",
    total_leave: "",
    leave_valid_until: "",
  });

  const FileterState = {
    status: "",
  };

  useEffect(() => {
    if (UserData != undefined && UserData.data) {
      if (
        UserData.data != undefined &&
        UserData.data != null &&
        UserData.data.first_name != undefined &&
        UserData.data.first_name != null
      ) {
        setEmployeeName(UserData.data.first_name.toUpperCase());
        setEmpRole(UserData.data.user_role.role);
        //  console.log(UserData, "UserData");
        dispatch(setTheWhiteCollarState(UserData.data.user_role.white_collar))
        setImages(UserData.data.user_sign_image?.media_url);
        console.log(UserData.data, "807304jild");
      }
    }
  }, [UserData]);

  // useEffect(() => {
  //   if (
  //     state.ShiftDatas.ShiftGetList != undefined &&
  //     state.ShiftDatas.ShiftGetList.branch_data != undefined &&
  //     state.ShiftDatas.ShiftGetList.branch_data.client_id != undefined &&
  //     state.ShiftDatas.ShiftGetList.branch_data.client_id.client_name !=
  //       undefined &&
  //     state.ShiftDatas.ShiftGetList.branch_data.zone_id != undefined &&
  //     state.ShiftDatas.ShiftGetList.branch_data.zone_id.zone_name != undefined
  //   ) {
  //     setStatus({
  //       ...Status,
  //       weekoff: state.ShiftDatas.ShiftGetList.weekoff,
  //       client_name:
  //         state.ShiftDatas.ShiftGetList.branch_data.client_id.client_name,
  //       zone_name: state.ShiftDatas.ShiftGetList.branch_data.zone_id.zone_name,
  //     });
  //   }
  // }, [state.ShiftDatas.ShiftGetList]);

  ///-------------------Avaiable--_Leave----
  // useEffect(() => {
  //   if (
  //     state.AttenDanceCall.AttenDanceData != undefined &&
  //     state.AttenDanceCall.AttenDanceData.data != undefined
  //   ) {
  //     setLeaveStatus({
  //       ...LeaveState,
  //       pending_leave:
  //         state.AttenDanceCall.AttenDanceData.data.casual_leave_pending,
  //       leave_valid_until:
  //         state.AttenDanceCall.AttenDanceData.data.leave_valid_until,
  //       total_leave:
  //         state.AttenDanceCall.AttenDanceData.data.casual_leave_pending,
  //     });
  //   }
  // }, [state.AttenDanceCall.AttenDanceData]);

  const dispatchApiCall = (payload) => {
    dispatch(SetTheAttendanceDatasActions(payload));
  };
  const getTimeDifference = (shiftStartTime) => {
    const currentDate = new Date();
    const [startHour, startMinute] = shiftStartTime.split(":").map(Number);
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();
    const startTimeInMinutes = startHour * 60 + startMinute;
    const currentTimeInMinutes = currentHour * 60 + currentMinute;
    let timeDifference = currentTimeInMinutes - startTimeInMinutes;
    // let timeDifference = 0;
    if (timeDifference < 0) {
      timeDifference = Math.abs(timeDifference);
      const hours = Math.floor(timeDifference / 60);
      const minutes = timeDifference % 60;
      return (
        <p>
          {" "}
          Your shift begins in {hours} hour and {minutes} minutes.
        </p>
      );
    } else {
      return null;
    }
  };
  const checkTime = (startTime) => {
    const [startHours, startMinutes, startSeconds] = startTime
      .split(":")
      .map(Number);
    const currentDate = new Date();
    const currentHours = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();
    const currentSeconds = currentDate.getSeconds();

    const startMillis =
      (startHours * 3600 + startMinutes * 60 + startSeconds) * 1000;
    const currentMillis =
      (currentHours * 3600 + currentMinutes * 60 + currentSeconds) * 1000;
    // const currentMillis = 800;
    if (startMillis > currentMillis) {
      setIsTimeAfter(true);
    }
  };
  ///---APi----Calls-----------
  useEffect(() => {
    const payload = {
      page_size: 10,
      page: 1,
      selectVal: {
        status: "",
      },
    };
    dispatch(SetTheAttendanceDatasActions(payload));
    dispatch(SetTheShiftDatasActions());
  }, []);

  const convertDateTime = (timestamp) => {
    const dateObj = new Date(timestamp);

    // Format the date part
    const datePart = dateObj.toISOString().split("T")[0];

    // Format the time part to 12-hour format with AM/PM
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const seconds = dateObj.getSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM/PM

    // Ensure two digits for minutes and seconds
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");

    const timePart = `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;

    return { datePart, timePart };
  };

  // ///---Shift---Details-----
  // useEffect(() => {
  //   if (
  //     state.ShiftDatas.ShiftGetList != undefined &&
  //     state.ShiftDatas.ShiftGetList.attendance_data != null &&
  //     state.ShiftDatas.ShiftGetList.from_time != null
  //   ) {
  //     SetEndtime(state.ShiftDatas.ShiftGetList.attendance_data.check_out_time);
  //     setstartTime(state.ShiftDatas.ShiftGetList.attendance_data.check_in_time);
  //     checkTime(state.ShiftDatas.ShiftGetList.attendance_data.check_in_time);
  //   }
  // }, [state.ShiftDatas.ShiftGetList]);
  // state.ShiftDatas.ShiftGetList.attendance_data.check_in_time
  useEffect(() => {
    if (
      state.ShiftDatas.ShiftGetList !== undefined &&
      state.ShiftDatas.ShiftGetList.attendance_data != null &&
      state.ShiftDatas.ShiftGetList.attendance_data.check_in_time != null &&
      state.ShiftDatas.ShiftGetList.attendance_data.check_in_time != undefined
    ) {
      const checkInTime =
        state.ShiftDatas.ShiftGetList.attendance_data.check_in_time;
      // const checkOutTime = state.ShiftDatas.ShiftGetList.attendance_data.check_out_time;

      const formattedCheckInTime = convertDateTime(checkInTime);
      // const formattedCheckOutTime = convertDateTime(checkOutTime);

      // SetEndtime(formattedCheckOutTime);
      setstartTime(formattedCheckInTime.timePart);
      checkTime(checkInTime);
    }

    if (
      state.ShiftDatas.ShiftGetList !== undefined &&
      state.ShiftDatas.ShiftGetList.attendance_data != null &&
      state.ShiftDatas.ShiftGetList.attendance_data.check_out_time != null &&
      state.ShiftDatas.ShiftGetList.attendance_data.check_out_time != undefined
    ) {
      const checkOutTime =
        state.ShiftDatas.ShiftGetList.attendance_data.check_out_time;
      const formattedCheckOutTime = convertDateTime(checkOutTime);
      SetEndtime(formattedCheckOutTime.timePart);
    }
    if (
      state.ShiftDatas.ShiftGetList != undefined &&
      state.ShiftDatas.ShiftGetList != null
    ) {
      setCheckIn(state.ShiftDatas.ShiftGetList.check_in);
      dispatch(setTheCheckingIn(state.ShiftDatas.ShiftGetList.check_in))
      if (
        state.ShiftDatas.ShiftGetList.branch_data != undefined &&
        state.ShiftDatas.ShiftGetList.branch_data != null
      ) {
        const Branch = {
          // latitude: state.ShiftDatas.ShiftGetList.branch_data.latitude,
          // longitude: state.ShiftDatas.ShiftGetList.branch_data.longitude,
          // latitude: 40.730610,  // Example latitude
          // longitude: -73.935242 // Example longitude
          latitude: state.ShiftDatas.ShiftGetList.branch_data.latitude,
          longitude: state.ShiftDatas.ShiftGetList.branch_data.longitude
        };
        dispatch(setTheBranchInlatANDLog(Branch));
      }

    }
    if (state.ShiftDatas.ShiftGetList.attendance_data != null && state.ShiftDatas.ShiftGetList.attendance_data != undefined) {
      dispatch(setTheAttendanceId(state.ShiftDatas.ShiftGetList.attendance_data.id))

    }

    else if (state.ShiftDatas.ShiftGetList.attendance_data == null || state.ShiftDatas.ShiftGetList.attendance_data == undefined) {
      dispatch(setTheAttendanceId(""))


    }

  }, [state.ShiftDatas.ShiftGetList]);


  const getCurrentDateFormatted = () => {
    const date = new Date();
    const options = { month: "short", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };


  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="OuterEmployee-Details">
          <div className="EmployeeDetails row">
          <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div
                    className="row "
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      className="col-sm-3 col-md-3 col-lg-1 d-flex justify-content-start ProfileImages"
                      style={{ minWidth: "117px", maxWidth: "114px" }}
                    >
                      <img src={state.SideBarFiles.UDSEmployeeeImage != null ?
                        state.SideBarFiles.UDSEmployeeeImage : Profile} width={"90px"} height={"90px"}

                      />
                    </div>
                    <div className="col-md-9 col-sm-12 col-lg-9 text-left">
                   
                      <h3 className="m-0 mt-2">
                        {EmployeeName}&nbsp; 

                      </h3>
                      <p style={{ fontWeight: 600, fontSize: "14px", marginLeft: "2px" }}>
                        {empRole}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ShiftDetails">
          <div className="row" style={{ padding: "5px  28px" }}>
            <div className="col-md-6 ShiftBasedCards margin ">
              <>
                {state.laguagefoetheemployees.COuntsForLanguage == 1 ? (
                  <>
                    <div className="row">
                      <div className="col-md-12">
                        {EnglishData.Home.ShiftContent.ShiftPart.map((item) => (
                          <div
                            className="card UDSEMPLOYEEPUNCHCARD"
                            style={{ borderRadius: "16px" }}
                          >
                            <div className="CardHeaderUDSEmp">
                              <h3>{getCurrentDateFormatted()}</h3>
                            </div>
                            <div className="card-body bodyModifier">
                              <div className="row">
                                <div className=" col-md-6 PUNCHINHEADER ">
                                  <h6>
                                    PUNCH IN TIME:
                                    <span>
                                      {StartTime == "" ||
                                        StartTime == undefined ||
                                        StartTime == null
                                        ? "-"
                                        : StartTime}
                                    </span>
                                  </h6>
                                </div>
                                <div className="col-md-6 PUNCHINHEADER">
                                  <h6>
                                    PUNCH OUT TIME:
                                    <span>
                                      {endTime == "" ||
                                        endTime == undefined ||
                                        endTime == null
                                        ? "-"
                                        : endTime}
                                    </span>
                                  </h6>
                                </div>
                                <div className=" col-md-6  PUNCHINBUTTON ">
                                  <button
                                    className={`InneerButtonImages ${!CheckIN ? "CHECKINTRUE" : "CHECKINFALSE"
                                      }`}
                                    onClick={() => {
                                      if (state.SideBarFiles.UDSEmployeeeImage != null && state.SideBarFiles.UDSEmployeeeImage != "") {
                                        navigate("/check_in_out");
                                      }
                                      else {
                                        toast.error(
                                          "Kindly upload profile Image",
                                          {
                                            position: toast.POSITION.TOP_RIGHT,
                                          }
                                        );
                                      }


                                    }}
                                    disabled={CheckIN ? true : false}
                                  >
                                    Punch In
                                  </button>
                                </div>
                                <div className="col-md-6   PUNCHINBUTTON ">
                                  <button
                                    className={`InneerButtonImages ${CheckIN ? "CHECKOUTTRUE" : "CHECKUTFALSE"
                                      }`}
                                    onClick={() => {
                                      if (state.SideBarFiles.UDSEmployeeeImage != null && state.SideBarFiles.UDSEmployeeeImage != "") {
                                        navigate("/check_in_out");
                                      }
                                      else {
                                        toast.error(
                                          "Kindly upload profile Image",
                                          {
                                            position: toast.POSITION.TOP_RIGHT,
                                          }
                                        );
                                      }

                                    }}
                                    disabled={!CheckIN ? true : false}
                                  >
                                    Punch Out
                                  </button>
                                </div>
                              </div>
                              <div className="col-12 ContentShift">
                                {isTimeAfter
                                  ? getTimeDifference(
                                    String(
                                      state.ShiftDatas.ShiftGetList.from_time
                                    )
                                  )
                                  : null}
                                {/* <p className="m-0">{item.Content}</p> */}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            </div>
            <div className="col-md-6 ShiftBasedCards margin "></div>
          </div>
        </div>

        {/* ------------------------React---Table-----------------------------\ */}
        <div
          className="responsive-table"
          style={{ padding: "12px 28px 0px 28px" }}
        >
          {/* <Table
            data={state.AttenDanceCall.Responsess}
            columns={columns}
            onChange={tochange}
            datacount={state.AttenDanceCall.Total_Count}
            pagesize={pagesize}
            pageindex={pageindex}
            dtpagesize={dtpagesize}
            dtpageindex={dtpageindex}
            value={state.NumberCounts.Options}
            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
          /> */}
          {/* <AttendanceTable
            tableData={state.AttenDanceCall.Responsess}
            dataCount={10}
            dispatchApiCall={dispatchApiCall}
          /> */}
        </div>
      </div>
    </>
  );
};

export default EmployeeDashboard;
